import { render, staticRenderFns } from "./JGspecialTestList.vue?vue&type=template&id=322b8e1d"
import script from "./JGspecialTestList.vue?vue&type=script&lang=js"
export * from "./JGspecialTestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports